export default __webpack_public_path__ + "static/media/mouse-02.d734f271.jpg";